module.exports = "/_next/static/images/rolex_model_background_pink_portrait-9d692cb56242948baed4cd4af9575328.jpg";